import { DiscountActionsScreen } from "./discount-actions.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";
import {
	ActiveDiscountActionEditRoutes,
	ArchivedDiscountActionEditRoutes,
} from "../discount-action-edit";

export const ActiveDiscountActionsRoutes: RouteDefinition[] = [
	{
		path: Paths.activeDiscountActions.path,
		element: <DiscountActionsScreen />,
		requiredPermissions: ["UserInAccountPermission_DiscountAdmin_Read"],
	},
	...ActiveDiscountActionEditRoutes,
];

export const ArchivedDiscountActionsRoutes: RouteDefinition[] = [
	{
		path: Paths.archivedDiscountActions.path,
		element: <DiscountActionsScreen isArchivePage />,
		requiredPermissions: ["UserInAccountPermission_DiscountAdmin_Read"],
	},
	...ArchivedDiscountActionEditRoutes,
];
